
    import Vue from "vue";
    import Component from "vue-class-component";
    import {Prop, Watch} from "vue-property-decorator";
    import guid from "@/guid";

    @Component
    export default class CheckboxInput extends Vue {
        @Prop({default: () => []})
        errorMessages!: string[];
        @Prop({default: false})
        checked!: boolean;
        @Prop({default: null})
        checkboxLabel!: string | null;
        @Prop({default: () => guid() })
        checkboxName!: string | null;
        @Prop({default: () => false })
        checkboxDisabled!: boolean | null;
        @Prop({default: () => "" })
        value!: string;
        @Prop({default: null})
        inputLabel!: string | null;
        @Prop({default: null})
        inputPlaceholder: string | undefined;
        @Prop({default: () => "text" })
        inputType!: string;
        @Prop({ default: () => guid() })
        inputId!: string | null;

        inputValue = this.value;
        checkboxValue = this.checked;

        created() {
            this.$watch(() => this.checked, () => {
                this.checkboxValue = this.checked;
            });
            this.$watch(() => this.value, () => {
                this.inputValue = this.value;
            });
        }
        
        onCheckboxChanged() {
            if (!this.checkboxValue) {
                this.inputValue = "";
                this.onInputChange(this.inputValue);
            }
            
            this.$emit('update:checked', this.checkboxValue);
        }
        
        onInputChange(newInput: string){
            this.$emit('input', newInput);
        }
    }
